/**
 * Da quello che l'host scrive in un campo a centesimi interi.
 *
 * Altrove si fa `replace(",", ".")` e basta, che su «120» o «85,50» va bene.
 * Sui conti di un mese no: «11.285,77» è come lo scrive chiunque copi un
 * numero da un estratto conto, e con quel trucco diventa 11,28 € — un mese
 * dichiarato mille volte più piccolo, salvato con un tap. Quindi:
 *
 * - con la virgola, i punti sono migliaia: «11.285,77» → 1128577;
 * - senza virgola, un punto seguito da gruppi di tre cifre è migliaia
 *   («11.285» → 1128500), altrimenti è il decimale («85.5» → 8550);
 * - vuoto vuol dire zero (una voce che non c'è), tutto il resto che non
 *   torna — lettere, due virgole, tre decimali, il meno — è `null`, e il
 *   modulo lo dice invece di indovinare.
 */
export function centesimiDa(testo: string): number | null {
  const pulito = testo.replace(/[\s€]/g, "");
  if (pulito === "") return 0;

  let normale: string;
  if (pulito.includes(",")) {
    if (!/^\d{1,3}(\.\d{3})*,\d{1,2}$|^\d+,\d{1,2}$/.test(pulito)) return null;
    normale = pulito.replace(/\./g, "").replace(",", ".");
  } else if (/^\d{1,3}(\.\d{3})+$/.test(pulito)) {
    normale = pulito.replace(/\./g, "");
  } else if (/^\d+(\.\d{1,2})?$/.test(pulito)) {
    normale = pulito;
  } else {
    return null;
  }

  const [interi, decimali = ""] = normale.split(".");
  return Number(interi) * 100 + Number(decimali.padEnd(2, "0"));
}

/** Il contrario, per riempire il campo quando si corregge: 1128577 → «11285,77». */
export function testoDa(centesimi: number): string {
  if (centesimi === 0) return "";
  const euro = Math.floor(centesimi / 100);
  const resto = centesimi % 100;
  return resto === 0
    ? String(euro)
    : `${euro},${String(resto).padStart(2, "0")}`;
}
